//change Color menu from white to black on hero section

//data
const header = document.querySelector('header.c-header');
const headerContact = document.querySelector(".c-header__contact");
const headerContactCTA = document.querySelector(".c-header__contact--cta");
const hamburgerMenu = document.querySelector(".c-header__hamburger__lines");
const sectionToChange = document.querySelector(".changeMenuColor");
const logo = document.querySelector(".c-main-logo");

//set header to black when page loaded
headerContact.classList.add("color-black");
header.classList.add('header--dark');
if (headerContactCTA.classList.contains('reverse')) {
  headerContactCTA.classList.add("border-black--reverse");
} else {
  headerContactCTA.classList.add("border-black");

}

hamburgerMenu.classList.add("background-black");
logo.classList.add("c-main-logo--dark");

//function on scroll whitch looking for scroll to 2 section

document.addEventListener("scroll", () => {
  if (document.documentElement.scrollTop > 0) {
    headerContact.classList.remove("color-black");
    headerContactCTA.classList.remove("border-black");
    if (headerContactCTA.classList.contains('reverse')) {
      headerContactCTA.classList.remove("border-black--reverse");
    } else {
      headerContactCTA.classList.remove("border-black");

    }
    hamburgerMenu.classList.remove("background-black");
    logo.classList.remove("c-main-logo--dark");
  } else {
    headerContact.classList.add("color-black");
    if (headerContactCTA.classList.contains('reverse')) {
      headerContactCTA.classList.add("border-black--reverse");
    } else {
      headerContactCTA.classList.add("border-black");

    }
    hamburgerMenu.classList.add("background-black");
    logo.classList.add("c-main-logo--dark");
  }
});
